import React from "react";
import "./context_components.css";
import { useSelector } from "react-redux";


export function DotLoader(props) {
  const { load, color } = useSelector(state => state.miStore);

  return (
    <div>
      {load &&
        <div className="dot-loading">
          <span
            style={{
              backgroundColor: color
            }}
          ></span>
          <span
            style={{
              backgroundColor: color
            }}></span>
          <span
            style={{
              backgroundColor: color
            }}></span>
        </div>}
    </div>
  );
}

export default DotLoader;